import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Navbar from "./components/Navbar";
import "./App.css"



function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );

}

export default App;
